import * as ReactDropdownMenu from '@radix-ui/react-dropdown-menu';
import type {
  DropdownMenuLabelProps,
  DropdownMenuPortalProps,
  DropdownMenuProps,
  DropdownMenuTriggerProps,
} from '@radix-ui/react-dropdown-menu';
import { ReactNode } from 'react';

import { twMerge } from '@/utils/tw-merge';

import { Button, ButtonProps } from '../Button/Button';
import { Divider } from '../Divider/Divider';

export const DropdownMenu = (props: DropdownMenuProps) => {
  return <ReactDropdownMenu.Root {...props} />;
};

DropdownMenu.Trigger = function DropdownMenuTrigger(
  props: DropdownMenuTriggerProps
) {
  return <ReactDropdownMenu.Trigger {...props} />;
};

DropdownMenu.Content = function DropdownMenuContent({
  children,
  container,
  contentProps = {},
}: {
  children: ReactNode;
  container?: DropdownMenuPortalProps['container'];
  contentProps?: Omit<
    ReactDropdownMenu.DropdownMenuContentProps,
    'className' | 'align'
  >;
}) {
  return (
    <ReactDropdownMenu.Portal container={container}>
      <ReactDropdownMenu.Content
        align="start"
        className="style-body z-[99999] flex flex-col items-start gap-0.5 rounded-sm bg-white p-0.5 text-gray-800 shadow-md"
        {...contentProps}
      >
        {children}
      </ReactDropdownMenu.Content>
    </ReactDropdownMenu.Portal>
  );
};

DropdownMenu.Button = function DropdownMenuButton(
  props: Omit<ButtonProps, 'variant'>
) {
  return (
    <ReactDropdownMenu.Item asChild>
      <Button {...props} variant="white" size={props.size ?? 'fullWidth'} />
    </ReactDropdownMenu.Item>
  );
};

DropdownMenu.Sub = function DropdownMenuSub(
  props: ReactDropdownMenu.DropdownMenuSubProps
) {
  return <ReactDropdownMenu.Sub {...props} />;
};

DropdownMenu.SubTrigger = function DropdownMenuSubTrigger(
  props: ReactDropdownMenu.DropdownMenuSubTriggerProps
) {
  return <ReactDropdownMenu.SubTrigger {...props} />;
};

DropdownMenu.SubContent = function DropdownMenuSubContent({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <ReactDropdownMenu.Portal>
      <ReactDropdownMenu.SubContent className="style-body z-[99999] flex flex-col items-start gap-0.5 rounded-sm bg-white p-0.5 text-gray-800 shadow-md">
        {children}
      </ReactDropdownMenu.SubContent>
    </ReactDropdownMenu.Portal>
  );
};

DropdownMenu.Label = function DropdownMenuLabel({
  children,
  className = '',
  ...props
}: DropdownMenuLabelProps) {
  return (
    <ReactDropdownMenu.Label
      className={twMerge(
        'style-body-small-bold px-2 py-1.5 text-black',
        className
      )}
      {...props}
    >
      {children}
    </ReactDropdownMenu.Label>
  );
};

DropdownMenu.Separator = function DropdownMenuSeparator() {
  return <Divider className="mx-2 my-1" />;
};
